export default "__VITE_ASSET__DOz2zvTr__"